import { identity } from "lodash";

export function findShopsInUseDuringLastHour(allShops, devices) {
  const shops = [];

  if (allShops) {
    if (allShops.length !== 0) {
      allShops.forEach((shop) => {
        if (!devices || devices.length === 0) return;
        const result = devices.findIndex((device, index) => {
          // console.log(index)
          return String(device.shop_id) === String(shop._id) && Date.parse(device.last_seen) > Date.now() - 3600000;
        });
        if (result !== -1) {
          shops.push(shop);
        }
      });
    }
  }

  return shops;
}

export function findShopsWithDevices(allShops, devices) {
  const shops = [];

  if (allShops) {
    if (allShops.length !== 0) {
      allShops.forEach((shop) => {
        const result = devices.findIndex((device) => {
          return String(device.shop_id) === String(shop._id);
        });
        if (result !== -1) shops.push(shop);
      });
    }
  }

  return shops;
}

export function findShopsWithSelectedPlaylists(allShops, devices, playlistsSources, noPlaying) {
  const shops = [];

  if (allShops) {
    if (allShops.length !== 0) {
      allShops.forEach((shop) => {
        const result = devices.findIndex((device) => {
          if (device.dev_type === "MA" && String(device.shop_id) === String(shop._id)) {
            if (device.conf) {
              if (
                device.conf.playlistEnable !== null &&
                device.conf.playlistEnable !== undefined &&
                device.conf.playlistIMSEnable !== null &&
                device.conf.playlistIMSEnable !== undefined
              ) {
                if (playlistsSources.includes("IMS") && device.conf.playlistIMSEnable === true) {
                  return true;
                }
                if (playlistsSources.includes("CMS") && device.conf.playlistEnable === true) {
                  return true;
                }
                if (device.conf.playlistEnable === false && device.conf.playlistIMSEnable === false) {
                  if (noPlaying) {
                    return true;
                  } else {
                    return false;
                  }
                }
              } else {
                if (noPlaying) {
                  return true;
                } else {
                  return false;
                }
              }
            }
          }
          return false;
        });

        if (result !== -1) shops.push(shop);
      });
    }
  }
  return shops;
}

export function findShopsWithDevicesPlayingPlaylists(allShops, devices, playlistsSources, noPlaying) {
  const shops = [];

  if (allShops) {
    if (allShops.length !== 0) {
      allShops.forEach((shop) => {
        const result = devices.findIndex((device) => {
          if (device.dev_type === "MA" && String(device.shop_id) === String(shop._id)) {
            if (device.meta && device.meta.playlistInfo && device.meta.playlistInfo.source) {
              console.log(device.meta.playlistInfo);
              if (noPlaying && device.meta.playlistInfo.playing === false) {
                return true;
              }
              if (
                device.meta.playlistInfo.playing === true &&
                playlistsSources.includes(device.meta.playlistInfo.source)
              ) {
                if (device.last_seen && Date.parse(device.last_seen) > Date.now() - 1800000) {
                  return true;
                }
              }
            }
          }
          return false;
        });
        if (result !== -1) shops.push(shop);
      });
    }
  }
  return shops;
}
